/**
 * Endpoints that issue or revoke the session's own tokens. TokenInterceptor
 * must never answer a 401 from one of these by refreshing.
 */
export const TOKEN_ENDPOINTS = ['Auth/RefreshToken', 'Auth/RevokeTokens'];
